ui-cms-text-image-video {
  @include clearfix();

  display: block;

  .movingImage {
    width: 100%;

    &--masked {
      object-fit: cover;
      mask-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 960 800" xmlns="http://www.w3.org/2000/svg"><path d="M2.28882e-05 172.516L837.636 2.00037C893.323 -9.33587 947.26 28.6592 958.105 86.8648C959.366 93.6275 960 100.501 960 107.391V627.489L122.364 798C66.6759 809.336 12.74 771.34 1.89447 713.134C0.634414 706.372 0 699.499 0 692.609L2.28882e-05 172.516Z" fill="%23fff"/></svg>');
      mask-size: 100% 100%;
    }
  }

  ui-cms-footnote-list {
    margin-top: 24px;
  }

  ui-cms-link-list {
    margin-top: 30px;
  }

  .image-wrapper + .ui-richtext,
  .image-wrapper + .ui-leadtext {
    margin-top: 12px;
  }

  .top ~ .content {
    margin-top: 20px;

    @include breakpoint($medium) {
      margin-top: 28px;
    }
  }

  ui-headline + .image-wrapper + div ui-leadtext {
    margin-top: 12px;

    @include breakpoint($medium) {
      margin-top: 20px;
    }
  }

  ui-richtext + .image-wrapper {
    margin-top: 20px;

    @include breakpoint($medium) {
      margin-top: 28px;
    }
  }

  /* image variants */
  .img-3cols {
    @include breakpoint($small) {
      float: left;
      margin-right: calc(100% * (30 / 613));
      width: calc(100% * (291 / 613));
    }

    @include breakpoint($medium) {
      margin-right: calc(100% * (30 / 934));
      width: calc(100% * (211 / 934));
    }
  }

  .img-4cols {
    @include breakpoint($small) {
      float: left;
      margin-right: calc(100% * (30 / 613));
      width: calc(100% * (291 / 613));
    }

    @include breakpoint($medium) {
      float: left;
      margin-right: calc(100% * (30 / 934));
      width: calc(100% * (291 / 934));
    }
  }

  .img-3cols,
  .img-4cols {
    div {
      clear: both;
    }

    &.image-wrapper + ui-richtext {
      margin-top: 0;
    }
  }

  .img-12cols {
    width: 100vw;
  }

  figcaption {
    @extend %caption;

    margin-top: 9px;

    span + .copy__copyright {
      margin-top: 6px;
    }

    .copy__copyright {
      @extend %caption;

      color: $ui-grey-plus-1;
      font-family: var(--skin-font-family-primary, $font-family-sans-serif);
      margin-top: 10px;
    }
  }

  ui-leadtext + ui-richtext {
    margin-top: 10px;
  }

  // when component belongs to layout md-9
  .columns-9 {
    @include breakpoint($small) {
      .img-3cols {
        width: calc(100% * (211 / 693));
        margin-right: calc(100% * (30 / 693));
      }

      .img-4cols {
        margin-right: calc(100% * (30 / 693));
        width: calc(100% * (291 / 693));
      }
    }
  }

  // when component belongs to layout md-8
  .columns-8 {
    @include breakpoint($small) {
      .img-3cols {
        width: calc(100% * (211 / 613));
        margin-right: calc(100% * (30 / 613));
      }

      .img-4cols {
        width: calc(100% * (291 / 613));
        margin-right: calc(100% * (30 / 613));
      }
    }
  }

  // when component belongs to layout md-6
  .columns-6 {
    @include breakpoint($small) {
      .img-3cols {
        width: calc(100% * (211 / 452));
        margin-right: calc(100% * (30 / 452));
      }

      .img-4cols {
        width: calc(100% * (291 / 452));
        margin-right: calc(100% * (30 / 452));
      }
    }
  }
}
